import { gql } from 'graphql-request';

export const getAllTagsQuery = gql`
  query GetAllTags {
    tags {
      id
      name
      description
    }
  }
`;
